import React from "react"
import { Box } from "@mui/material"

import { AppDialogCancel, AppFormDrawer, AppFormGrid, AppFormSection } from "@components"
import { isEditUserSettingsCategoryDrawer, isOpenUserSettingsCategoryDrawer, userSettingCategoryFormData } from "../../../@signals"
import UserSettingCategoryDrawerColor from "./Color"
import UserSettingCategoryDrawerCategory from "./Category"
import UserSettingCategoryDrawerSubmit from "./Submit"


export default function UserSettingCategoryDrawer() {
	const onClose = () => userSettingCategoryFormData.value = { }

	return <AppFormDrawer
		icon="palette"
		title={isEditUserSettingsCategoryDrawer.value ? 'Edit category' : 'New category'}
		subtitle="A category and its colour"
		isOpen={isOpenUserSettingsCategoryDrawer.value}
		controller={onClose}
		footer={<>
			<AppDialogCancel onClick={onClose}/>
			<UserSettingCategoryDrawerSubmit/>
		</>}
	>
		<AppFormSection icon="palette" title="Category">
			<AppFormGrid>
				<Box sx={{ gridColumn: 'span 12' }}><UserSettingCategoryDrawerCategory/></Box>
				<Box sx={{ gridColumn: 'span 12' }}><UserSettingCategoryDrawerColor/></Box>
			</AppFormGrid>
		</AppFormSection>
	</AppFormDrawer>
}
